export default "__VITE_ASSET__C9PR5Jiv__"